import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
import { OFFER_ANCHOR } from '../data/config';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      timer = setTimeout(hide, 5000);
    };
    const hide = () => {
      setVisible(false);
      timer = setTimeout(() => {
        setIndex(i => (i + 1) % recentBuyers.length);
        show();
      }, 8000);
    };
    timer = setTimeout(show, 4000);
    return () => clearTimeout(timer);
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-3 left-3 z-50 w-[250px] sm:bottom-4 sm:left-4" aria-live="polite" data-id="element-150" data-mp="1gwufeb0wwgi7">
      <AnimatePresence data-id="element-151" data-mp="117frg5fx9zsx">
        {visible && !dismissed && <motion.div key={buyer.name} initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 14,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative" data-id="element-152" data-mp="114tj43l7jg9n">
            <a href={OFFER_ANCHOR} className="flex items-start gap-2.5 rounded-lg border-[3px] border-orange-500 bg-amber-300 px-3 py-2.5 shadow-lg" data-id="element-153" data-mp="i9v08rpoqp55">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-600" data-id="element-154" data-mp="s4n1q6me1w57">
                <CheckIcon className="h-3 w-3 text-white" strokeWidth={4} aria-hidden data-id="element-155" data-mp="28mkgvs4oxt72" />
              </span>
              <span className="min-w-0 leading-tight" data-id="element-156" data-mp="23npmru19wi7n">
                <span className="block text-xs font-extrabold uppercase text-blue-950" data-id="element-157" data-mp="2anrur3odj6gw">{buyer.name}</span>
                <span className="block text-[11px] text-blue-950/80" data-id="element-158" data-mp="2fm35rhqenn0p">{buyer.place}</span>
                <span className="mt-1 block text-[11px] font-bold text-blue-950" data-id="element-159" data-mp="2ko2aow1smrzr">
                  Acaba de comprar el Combo Completo Electricistas
                </span>
                <span className="block text-[10px] font-extrabold uppercase text-orange-800" data-id="element-160" data-mp="1rylle79gzr7r">
                  Hace {buyer.minutes} minutos
                </span>
              </span>
            </a>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full border-2 border-blue-950 bg-white text-blue-950" data-id="element-161" data-mp="21vpzdjt5wgdh">
              <XIcon className="h-3 w-3" strokeWidth={3} data-id="element-162" data-mp="1e5vlr010qns6" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}